import {
  type PlainDate,
  type ZonedDateTime,
  getCurrentTime,
} from "@sa-nu/shared-utils/date";

import { RESERVATION_CLOSE_THRESHOLD_HOUR } from "../../../../constants";

/**
 * レガシー ticket-reservation-form の getMinNight と同じ当日15時カットオフを
 * 部屋タイプフローにも効かせるための、選択可能な最短初泊日。
 */
export function getSameDayMinNight(
  currentTime: ZonedDateTime = getCurrentTime(),
): PlainDate {
  const today = currentTime.toPlainDate();
  return today.add({
    days: currentTime.hour >= RESERVATION_CLOSE_THRESHOLD_HOUR ? 1 : 0,
  });
}
